import { useTranslation } from 'react-i18next';

export interface BulkAction {
  key: string;
  label: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
}

interface BulkActionsBarProps {
  count: number;
  actions: BulkAction[];
}

export const BulkActionsBar = ({ count, actions }: BulkActionsBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 px-4 py-2 bg-gray-50">
      <span className="text-sm text-gray-700">{t('admin.common.rows_selected', { count })}</span>
      <div className="flex flex-wrap gap-2 sm:ml-auto">
        {actions.map((action) => (
          <button
            key={action.key}
            onClick={action.onClick}
            className={`px-3 py-1.5 text-sm font-medium rounded-md border transition ${
              action.variant === 'danger'
                ? 'border-red-200 text-red-600 hover:bg-red-50'
                : 'border-gray-300 text-gray-700 hover:bg-white'
            }`}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};
